import type { Collection } from '../types/catalog'

export const collections: Collection[] = [
  {
    id: 'chains',
    label: 'Chains & Necklaces',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/98818029-fe8a-4ec6-9a72-ba837b99e23f.jpg',
  },
  {
    id: 'studs',
    label: 'Stud Earrings',
    image:
      'https://cdn.magicpatterns.com/uploads/uTLe7vajVzv4KfwfP5w8nU/Stud_Earrings_(1).jpg',
  },
  {
    id: 'hoops',
    label: 'Hoop Earrings',
    image:
      'https://cdn.magicpatterns.com/uploads/dbBwwgJvcRC9Pg5TQxdd53/Hoop_Earrings_(1).jpg',
  },
  {
    id: 'bracelets',
    label: 'Bracelets',
    image:
      'https://cdn.magicpatterns.com/uploads/fYY4Gk9UwTBZS6WfmkTxZb/Braceletsjpeg.webp',
  },
  {
    id: 'pendants',
    label: 'Pendants',
    image: 'https://cdn.magicpatterns.com/uploads/v7eFX3KZa3M1Zpk5Tde6Uh/_pendants.webp',
  },
  {
    id: 'rings',
    label: 'Rings',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/952c08a4-b1f2-4965-aa91-98a82f8b21fe.jpg',
  },
]
